import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/sections/footer.scss';
import ClientsLogoFooter from '../components/client-logos-footer';

const Footer = (props) => { 
    // if(document.body.classList.contains('template-home'){

    // )
    return(
        <footer id={props.extraClass} className="tac">
            <div className="footerRow1 whiteBg">
                <ul className="footerLinks">
                    <li>
                        <Link 
                            to="/portfolio"
                            className="btn pill dark sm"
                            >
                            Portfolio
                        </Link>
                    </li>
                    {/* <li>
                        <Link 
                            to="/"
                            className="btn pill dark sm"
                            >
                            Case Studies
                        </Link>
                    </li> */}
                    <li> 
                        <Link 
                            to="/clients"
                            className="btn pill dark sm"
                            >
                            Client List
                        </Link>                     
                    </li>
                </ul>
                <ul className="footerSocial">
                    <li><a href="/" className="fb">FACEBOOK</a></li>
                    <li><a href="/" className="lk">LINKEDIN</a></li>
                    <li><a href="/" className="tw">TWITTER</a></li><br className="mobile-only"/>
                    <li><a href="/" className="cl">CLUTCH</a></li>
                    <li><a href="/" className="db">DRIBBLE</a></li>
                </ul>
            </div>
            <div className="footerRow2 lightGrayBg">
                <h4>We bug you, have fun and get serious at times too!</h4>
                <p>SERIOUSLY, JUST ASK THEM</p>                
                <ClientsLogoFooter />
            </div>
            <div className="footerRow3 darkGrayBg">
                <h4 className="light">Got a project? Let’s discuss.</h4>
                <Link 
                    to="get-quote"
                    className="btn pill sm"
                    >
                Keep In Touch
                </Link>
            </div>
        </footer>
    )
}

export default Footer;